import { lazy } from 'react';

const WebsiteAd = lazy(() => import('./website-ad'));
const VideoAd = lazy(() => import('./video-ad'));

export { WebsiteAd, VideoAd };
